import { ItemPredicate } from '@blueprintjs/select';
import { IItem } from 'app/components/search-bar/SearchBar';

export const filterSearchBarResults: ItemPredicate<IItem> = (query, item, _index, exactMatch) => {
  if (!query) return true;

  const normalizedSearchString = (item.searchString && item.searchString.toLowerCase()) || '';
  const normalizedQuery = query.toLowerCase();

  if (exactMatch) {
    return normalizedSearchString === normalizedQuery;
  } else {
    return normalizedQuery.split(' ').every(v => normalizedSearchString.indexOf(v) >= 0);
  }
};
